export default "__VITE_ASSET__DAIOfhO9__"